<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <user-list></user-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import UserList from './UserProfile/UserList.vue'

  export default {
    components: {
      UserList
    }
  }

</script>
<style>

</style>
